import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'questions';

class QuestionService {
    create({parentId, question}) {
        return axios
            .post(API_URL, {
                parentId: parentId,
                title: question.title,
                reserved: question.reserved,
                level: question.level
            });
    }
    update(question) {
        return axios.put(API_URL, {
            id: question._id,
            title: question.title,
            reserved: question.reserved,
            level: question.level,
            answers: question.answers
        });
    }
    delete(id) {
        return axios.delete(API_URL, { data: {id: id}});
    }
    all(parentId) {
        return axios.post(API_URL, {
            id: parentId
        })
    }
}

export default new QuestionService